import { Component } from 'js-component-framework';
import PositionSticky from 'utils/PositionSticky';
import Toggle from 'utils/Toggle';
import './header.scss';

/**
 * Component for site header and drawer.
 */
export default class Header extends Component {
  /**
   * Start the component
   */
  constructor(config) {
    super(config);
    this.setupHeader();
  }

  /**
   * Add flyout class.
   */
  onFlyoutToggle() {
    const openMenus = this.querySelectorAll('[aria-expanded="true"]');
    if (0 < openMenus.length) {
      document.body.classList.add('flyout-active');
    } else {
      document.body.classList.remove('flyout-active');
    }
  }

  setupHeader() {
    const {
      burger,
      controllers,
    } = this.children;

    Array.prototype.slice.call(['popuphide', 'popupshow']).forEach((event) => {
      this.element.addEventListener(event, this.onFlyoutToggle);
    });

    this.sticky = new PositionSticky( // eslint-disable-line no-unused-vars
      this.element,
      {
        stick: 'stuck',
      }
    );

    if (burger) {
      const burgerFlyout = burger.nextElementSibling;
      if (burgerFlyout) {
        this.burgerTime = new Toggle({
          children: {
            controller: burger,
            target: burgerFlyout,
          },
        });
      }
    }

    Array.prototype.slice.call(controllers).forEach((controller) => {
      const target = controller.parentElement.querySelector('.nav__section');
      if (null !== target) {
        this.menuSection = new Toggle({
          children: {
            controller,
            target,
          },
        });
      }
    });
  }
}
